import { apiClient } from './client';

export const checkupApi = {
  getAll: (params) => apiClient.get('/checkups', { params }),
  getById: (id) => apiClient.get(`/checkups/${id}`),
  getByChild: (childId) => apiClient.get(`/checkups/child/${childId}`),
  getEventStats: (eventId) => apiClient.get(`/checkups/event/${eventId}/stats`),
  create: (data) => apiClient.post('/checkups', data),
  update: (id, data) => apiClient.put(`/checkups/${id}`, data),
  delete: (id)       => apiClient.delete(`/checkups/${id}`),
};
